import * as angular from "angular";
import {IController, IQService, IRootScopeService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentMapService} from "../../services/agent-map-service.service";
import {CircleMarkersService} from "../../services/circle-markers";
import {DeliveryStopoversService} from "../../services/delivery-stopovers.service";
import {ItineraryMapService} from "../../services/itinerary-map-service.service";
import {MapFactoryService} from "../../services/map.service";
import {MapRouteService} from "../../services/route-service.service";
import {TrafficService} from "../../services/traffic.service";
import {PolylineService} from "../../services/polyline.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {AgentMarkerService} from "../../services/agent-marker.service";

export class BringozMapComponent implements IController {
  deliveryTaskIds: any;
  selectDelivery: any;
  selectedDeliveriesIds: any;
  deliveryTasks: any;
  createOrderTasks: any;
  circles: any;
  simpleMap: any;

  private filter: any = {
    services: {
      enabled: false,
    },
    itinerary: {
      enabled: false,
    },
    agents: {
      enabled: false,
    }
  };
  map: any;

  constructor(private mapFactoryService: MapFactoryService, private deliveryTaskMarkersService: DeliveryStopoversService, private $delivery, private mapConstant,
              private splitService: SplitService, private itineraryMapService: ItineraryMapService,
              private agentMapService: AgentMapService, private $log, private mapRouteService: MapRouteService, private $q: IQService, private $scope,
              private $timeout: ITimeoutService, private $rootScope: IRootScopeService, private $element,
              private agentMarkersService: AgentMarkerService, private circleMarkersService: CircleMarkersService, private trafficService: TrafficService, private polylineService: PolylineService) {
  }

  $onInit() {
    this.$scope.courierMarker = [];
    this.$scope.taskMarkers = [];
    this.$scope.servicesPolyline = [];
    this.$scope.orderServiceMarkers = [];
    this.$scope.serviceTaskMarkers = {};


    this.$scope.enabledFilters = {
      traffic: true,
      services: false,
      itinerary: false,
      agents: false
    };
    this.$rootScope.$on('resizeMap', () => this.mapResize());
    this.$scope.$watch('map', (map) => {
      if (!map) {
        return;
      }

      /*************
       * Events    *
       *************/

      this.$rootScope.$on('select-agent', (ev, id) => {
        this.agentMarkersService.panToAgent(this.$scope.courierMarker, id, map);
      });

      this.$scope.$on(this.mapConstant.events.doCenter, () => {
        this.centerMap();
      });

      /*************************
       * Circles     *
       *************************/

      this.$scope.circleMarkersService = [];
      this.$scope.itineraryMarkers = [];
      this.$scope.$watch('circles', (circles) => {
        this.circleMarkersService.clearAll(this.$scope.circleMarkersService);
        this.deliveryTaskMarkersService.clearAll(this.$scope.itineraryMarkers);
        // this.circleMarkers.clearAll(this.$scope.itineraryMarkers);
        this.$scope.circleMarkers = [];
        this.$scope.itineraryMarkers = [];
        if (!circles) {
          return;
        }

        circles.forEach((circle) => {
          this.showItinerary(_.map(circle.taskListExt, 'id'), circle.agentId, false);
          this.$scope.circleMarkersService.push(this.circleMarkersService.createCircle(map, circle));
        });
        this.filter.circles = true;
        this.$scope.enabledFilters.circles = true;
        this.centerMap();
      });

      /*************************
       * Site Market     *
       *************************/

      this.$scope.taskSuggestions = [];
      this.$scope.deliveryTaskMarkersList = [];

      this.$rootScope.$on(this.mapConstant.events.siteMarket.displayDeliveryTaskMarkers, (event, serviceIds) => {

        if (serviceIds) {
          this.$scope.deliveryTaskMarkersList = [];

          _.set(this.$scope, 'filter.services.enabled', true);
          _.set(this.$scope, 'enabledFilters.services', true);

          this.getAsyncServices(serviceIds).then(
            (services) => {
              _.forEach(services, (service) => {
                var deliveryMarkersList = this.serviceToMarkers(service);
                _.forEach(deliveryMarkersList, (marker) => {
                  this.registerToEvents(marker);
                  this.$scope.deliveryTaskMarkersList.push(marker)
                });
              });
              this.centerMap();
            },
            (error) => {
              this.$log.error('Failed to get services at ' +
                'bringozMap@mapConstant.events.siteMarket.displayDeliveryTaskMarkers \n' + error)
            }
          );
        }

      });

      this.$rootScope.$on(this.mapConstant.events.siteMarket.displaySuggestedMarkers, (event, suggestedTasks) => {
        this.$scope.taskSuggestions = [];
        if (suggestedTasks) {
          suggestedTasks.forEach((task: TaskModel) => {
            if (_.get(task, 'taskSpec.address.location')) {
              const marker = this.deliveryTaskMarkersService.taskToSuggestionMarker(map, task);
              this.registerToEvents(marker);
              this.$scope.taskSuggestions.push(marker);
            }
          });

          this.centerMap();

          this.filter.suggestions = true;
          this.$scope.enabledFilters.suggestions = true;
        }
      });


      this.$rootScope.$on(this.mapConstant.events.siteMarket.removeDeliveryTaskMarkers, (event) => {
        this.removeDeliveryTaskMarkersFromMap();
      });

      this.$rootScope.$on(this.mapConstant.events.siteMarket.removeSuggestedMarkers, (event) => {
        this.removeSuggestionsTaskMarkersFromMap();
      });


      this.$rootScope.$on(this.mapConstant.events.siteMarket.taskMarkersBounce, (event, taskIdList) => {

        if (_.isUndefined(this.$scope.deliveryTaskMarkersList)) {
          this.$scope.deliveryTaskMarkersList = [];
        }

        if (_.isUndefined(this.$scope.taskSuggestions)) {
          this.$scope.taskSuggestions = [];
        }

        const allSiteMarketMarkers = this.getAllSiteMarketMarkers();
        this.setBounce(allSiteMarketMarkers, taskIdList);
      });


      this.$rootScope.$on(this.mapConstant.events.siteMarket.stopAllMarkersBounce, (event) => {
        this.stopAllMarkerBounce();
      });

      this.$rootScope.$on(this.mapConstant.events.siteMarket.resizeMap, (event) => {
        this.resetAllMarkersSelected();
        this.centerMap();
      });


      /*************************
       * Delivery tasks     *
       *************************/


      this.$scope.$on(this.mapConstant.events.services.display, (event, serviceIds) => {
        if (serviceIds) {

          _.set(this.$scope, 'filter.services.enabled', true);
          _.set(this.$scope, 'enabledFilters.services', true);

          this.clearServiceTaskMarker(this.$scope.serviceTaskMarkers);
          this.$scope.serviceTaskMarkers = {};

          this.getAsyncServices(serviceIds).then(
            (services) => {
              _.forEach(services, (service) => {
                const markers = this.serviceToMarkers(service);
                if (!_.get(this.$scope.serviceTaskMarkers, service.id, false)) {
                  _.set(this.$scope.serviceTaskMarkers, service.id, markers);
                }
              });

              this.centerMap();
            },
            (error) => {
              this.$log.error('Failed to get services at ' +
                'bringozMap@mapConstant.events.services.display \n' + error)
            }
          );
        }

      });

      this.$scope.$on(this.mapConstant.events.services.removeSelected, (event, serviceId) => {

        if (serviceId) {
          var markers = _.get(this.$scope.serviceTaskMarkers, serviceId);

          if (markers) {
            this.setMarkers(markers, false);
          }
        }
      });

      this.$scope.$on(this.mapConstant.events.services.selectedIds, (event, serviceIds) => {
        if (_.isArray(serviceIds) && !_.isEmpty(serviceIds)) {
          _.forEach(serviceIds, (serviceId) => {
            var markers = _.get(this.$scope.serviceTaskMarkers, serviceId);
            this.setMarkers(markers, true);
          });
        } else {
          _.forEach(this.$scope.serviceTaskMarkers, (markers) => {
            this.setMarkers(markers, false);
          });
        }

      });

      this.$scope.$on(this.mapConstant.events.services.byOrder, (event, services) => {

        if (_.isArray(services) && !_.isEmpty(services)) {

          this.clearServiceTaskMarker(this.$scope.orderServiceMarkers);
          this.$scope.orderServiceMarkers = this.drawServiceMarkers(services);

          this.mapRouteService.draw(this.$scope, map, services);

          this.centerMap();
        }

      });

      this.$scope.$on(this.mapConstant.events.services.clearByOrder, (event) => {

        this.clearServiceTaskMarker(this.$scope.orderServiceMarkers);
        this.$scope.orderServiceMarkers = [];
        this.centerMap();

      });

      //$scope.$watch('createOrderTasks', function (_tasks) {
      //    if (_.isArray(_tasks) && !_.isEmpty(_tasks)) {
      //        drawTasksMarkers(_tasks);
      //        polyline.clearPolylines($scope.tasksPolylines);
      //        $scope.tasksPolylines = polyline.displayPolylinePerService(map, $scope.taskMarkers);
      //        centerMap();
      //    }
      //}, true);


      this.$scope.$watch('deliveryTasks', (_tasks) => {
        if (_.isArray(_tasks) && !_.isEmpty(_tasks)) {

          this.polylineService.clearPolyline(_.get(this.$scope, 'tasksPolyline'));
          this.drawTasksMarkers(_tasks);
          this.$scope.tasksPolyline = this.polylineService.createPolyline(map, this.$scope.taskMarkers);
          this.centerMap();
        }
      }, true);

      this.$scope.$watch('deliveryTaskIds.length', (length, oldLength) => {
        if (length) {
          this.$scope.enabledFilters.tasks = true;
          if (oldLength) {
            var newIds = _.slice(this.$scope.deliveryTaskIds, oldLength);
            var newMarkers = this.deliveryTaskMarkersService.deliveryTasksToMarkers(map, newIds, this.$scope.selectedDeliveriesIds, this.filter.tasks, this.$scope.simpleMap);

            this.$scope.taskMarkers = _.concat(this.$scope.taskMarkers, newMarkers);
          } else {
            this.filter.tasks = true;
            this.deliveryTaskMarkersService.clearAll(this.$scope.taskMarkers);
            this.$scope.taskMarkers = this.deliveryTaskMarkersService.deliveryTasksToMarkers(map, this.$scope.deliveryTaskIds, this.$scope.selectedDeliveriesIds, true, this.$scope.simpleMap);
            this.centerMap();
          }

          this.createCluster();
        } else if (!this.$scope.deliveryTasks) {
          this.filter.tasks = false;
          this.$scope.enabledFilters.tasks = false;
          this.deliveryTaskMarkersService.clearAll(this.$scope.taskMarkers);

          this.$scope.taskMarkers = [];
          this.createCluster();
        }
      });

      /*************
       * Start Agents *
       *************/

      this.$scope.$on(this.mapConstant.events.agents.displayAll, (event, agentIds) => {
        this.agentMapService.draw(this.$scope, map, agentIds).then(
          (markers) => {
            this.centerMap();
            this.filter.agents.enabled = true;
            this.$scope.enabledFilters.agents = true;
          },
          (error) => {
            this.$log.debug(error);
          }
        );
      });

      this.$scope.$on(this.mapConstant.events.agents.hide, (event, agentIds) => {
        this.agentMapService.hide();
      });

      /*************
       * End Agents *
       *************/

      /*************
       * Start Itinerary *
       *************/

      this.$rootScope.$on(this.mapConstant.events.itinerary.selectMarker, (event, taskId) => {
        this.itineraryMapService.selectMarker(taskId);
      });

      this.$scope.$on(this.mapConstant.events.itinerary.draw, (event, allStops, isCompletedItinerary) => {

        //TODO remove this shitty patch.
        //////////////////////////////////////////////////
        const agentStop = _.find(allStops, (stop) => {
          return _.isEqual(stop.type, 'agent');
        });
        allStops.splice(allStops.indexOf(agentStop), 1);
        const taskIds = _.map(allStops, (stop) => {
          return stop.id;
        });
        //////////////////////////////////////////////////

        this.showItinerary(taskIds, agentStop.id, isCompletedItinerary);
      });

      this.$scope.$on(this.mapConstant.events.itinerary.hide, (event) => {
        this.itineraryMapService.hide(true);
        this.filter.itinerary.enabled = false;
        this.$scope.enabledFilters.itinerary = false;
      });

      /*************
       * End Itinerary *
       *************/

      /*************
       * Start Tasks *
       *************/

      this.$scope.$watch('filter.tasks', (tasks) => {
        if (tasks) {
          this.$scope.taskMarkers.forEach((marker) => {
            marker.setMap(map);
          });
          if (this.$scope.cluster)
            this.$scope.cluster.setMap(map);
        } else {
          this.$scope.taskMarkers.forEach((marker) => {
            marker.setMap(null);
          });
          if (this.$scope.cluster)
            this.$scope.cluster.setMap(null);
        }
      });

      /*************
       * End Tasks *
       *************/

      /*************
       * Start Traffic *
       *************/

      this.$scope.$watch('filter.traffic', (Traffic) => {
        if (this.$scope.trafficLayer) {
          this.trafficService.hide(this.$scope.trafficLayer);
          this.$scope.trafficLayer = null;
        }

        if (Traffic) {
          this.$scope.trafficLayer = this.trafficService.createLayer(map);
        }
      });

      /*************
       * End Traffic *
       *************/

      this.$scope.$emit(this.mapConstant.events.ready);

    });

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.circles) {
      this.$scope.circles = angular.copy(this.circles);
    }
  }

  $postLink() {
    this.mapFactoryService.createMap(this.$element.find('.the-map')[0]).then((map) => {
      this.$scope.map = map;
    });
  }

  getAsyncServices(serviceIds) {
    let promises = [];

    _.forEach(serviceIds, (id) => {
      const deferred = this.$q.defer();

      this.$delivery(id).$asyncValue().then(
        (delivery) => {
          deferred.resolve(delivery);
        },
        (error) => {
          this.$log.error('Failed to get delivery from server ' +
            'bringozMap@getAsyncServices \n' + error);
        }
      );
      promises.push(deferred.promise);
    });

    return this.$q.all(promises)
  }

  showItinerary(taskIds, agentId, isCompletedItinerary) {
    this.itineraryMapService.draw(this.$scope, this.$scope.map, taskIds, agentId, isCompletedItinerary).then(
      (res) => {
        const markers = res[0][0];
        this.mapResize();
        this.centerMapNew(markers);
        this.filter.itinerary.enabled = true;
        this.$scope.enabledFilters.itinerary = true;

        // Used for center map from map icon
        this.$scope.itineraryMarkers = markers;
        // this.$scope.itineraryMarkers = markers[0].concat(markers[1]);
      },
      (error) => {
        this.$log.debug(error);
      }
    );
  }

  centerMapNew(markers) {

    if (!_.isEmpty(markers)) {
      const bounds = new google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        bounds.extend(marker.position);
      });

      this.$scope.map.fitBounds(bounds);
    }
  }

  drawServiceMarkers(_services) {

    let serviceMarkers = [];

    _.forEach(_services, (_service) => {
      let taskMarkers = this.serviceToMarkers(_service);
      serviceMarkers.push(taskMarkers);
    });

    return serviceMarkers;
  }

  drawTasksMarkers(_tasks) {
    if (_.isArray(_tasks)) {
      this.deliveryTaskMarkersService.clearAll(this.$scope.taskMarkers);
      _.set(this.$scope, 'taskMarkers', []);

      _.forEach(_tasks, (_task) => {
        const taskLocation = _.get(_task, 'taskSpec.address.location');
        if (!_.isEmpty(taskLocation)) {
          const marker = this.deliveryTaskMarkersService.taskToMarker(this.$scope.map, _task, false);
          this.$scope.taskMarkers.push(marker);
        }
      });

      _.set(this.$scope, 'filter.tasks', true);
      _.set(this.$scope, 'enabledFilters.tasks', true);
    }
  }


  serviceToMarkers(service) {
    let taskList = _.get(service, 'taskList', []),
      taskMarkers = [];

    _.forEach(taskList, (_task) => {
      const taskLocation = _.get(_task, 'taskSpec.address.location');
      if (!_.isEmpty(taskLocation)) {
        const marker = this.deliveryTaskMarkersService.taskToMarker(this.$scope.map, _task, false, true);
        taskMarkers.push(marker);
      }
    });

    return taskMarkers;
  }

  createCluster() {

  }


  centerToCircles() {
    this.mapFactoryService.centerToCircles(this.$scope.map, this.$scope.circleMarkersService);
  }

  centerMap() {
    this.mapResize();

    if (_.get(this.$scope.circleMarkersService, 'length')) {
      return this.centerToCircles();
    }

    let markersToFitBy = [];

    if (!_.isEmpty(this.$scope.taskMarkers) && this.filter.tasks) {
      markersToFitBy.push(this.$scope.taskMarkers);
    }

    // For centering itinerary markers
    if (!_.isEmpty(this.$scope.itineraryMarkers)) {
      markersToFitBy.push(this.$scope.itineraryMarkers);
    }

    if (this.filter.services.enabled) {

      _.forEach(this.$scope.serviceTaskMarkers, function (markers) {
        markersToFitBy.push(markers);
      });

    }

    if (this.filter.agents) {
      const markers = this.agentMapService.getMarkers();
      if (!!markers.length) {
        markersToFitBy.push(markers);
      }
    }

    _.forEach(this.$scope.orderServiceMarkers, function (markers) {
      markersToFitBy.push(markers);
    });

    if (markersToFitBy.length) {
      this.mapFactoryService.centerMap(this.$scope.map, markersToFitBy);
    } else {
      var bounds = new google.maps.LatLngBounds();

      this.$scope.map.fitBounds(bounds.extend(this.splitService.getSiteAddress().location));
      this.$scope.map.setZoom(15);
    }
  }

  clearServiceTaskMarker(serviceTaskMarkers) {
    _.forEach(serviceTaskMarkers, function (markers) {
      _.forEach(markers, function (marker) {
        marker.setMap(null);
      });
    });
  }

  setServiceMarkersMap(serviceTaskMarkers) {
    _.forEach(serviceTaskMarkers, (markers) => {
      _.forEach(markers, (marker) => {
        marker.setMap(this.$scope.map);
      });
    });
  }

  setMarkers(markers, selected) {
    _.forEach(markers, (marker) => {
      this.deliveryTaskMarkersService.setTaskMarker(marker, selected);
    });
  }

  toggleServiceMarkers(enabled) {

    if (enabled) {
      this.setServiceMarkersMap(this.$scope.serviceTaskMarkers);
    } else {
      this.clearServiceTaskMarker(this.$scope.serviceTaskMarkers);
    }

  }

  toggleItinerary(enabled) {
    enabled ? this.itineraryMapService.show(this.$scope.map) : this.itineraryMapService.hide();
  }

  toggleAgents(enabled) {
    enabled ? this.agentMapService.show(this.$scope.map) : this.agentMapService.hide();
  }

  mapResize() {
    this.$timeout(250)
      .then(() => {
        if (this.$scope.map) {
          google.maps.event.trigger(this.$scope.map, 'resize');
        }
      });
  }


  setBounce(markersList, taskIdList) {
    // taskIdList represents the task/tasks Id that needs to highlight

    if (!_.isEmpty(markersList)) {
      _.forEach(markersList, function (marker) {
        var markerToBounceIndex = _.findIndex(taskIdList, function (taskId) {
          return _.isEqual(taskId, marker.id);
        });

        if (!_.isEqual(markerToBounceIndex, -1)) {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        } else {
          marker.setAnimation(null);
        }
      })
    }
  }

  stopAllMarkerBounce() {
    const allSiteMarketMarkers = this.getAllSiteMarketMarkers();

    if (!_.isEmpty(allSiteMarketMarkers)) {
      _.forEach(allSiteMarketMarkers, (marker) => {
        marker.setAnimation(null);
      })
    }
  }

  stopAllOtherMarkerBounce(markerId) {
    const allSiteMarketMarkers = this.getAllSiteMarketMarkers();

    if (!_.isEmpty(allSiteMarketMarkers)) {
      _.forEach(allSiteMarketMarkers, (marker) => {
        if (!_.isEqual(marker.id, markerId)) {
          marker.setAnimation(null);
        }
      })
    }
  }

  getAllSiteMarketMarkers() {
    return this.$scope.deliveryTaskMarkersList.concat(this.$scope.taskSuggestions);
  }

  removeDeliveryTaskMarkersFromMap() {
    if (!_.isUndefined(this.$scope.deliveryTaskMarkersList) && !_.isEmpty(this.$scope.deliveryTaskMarkersList)) {
      _.forEach(this.$scope.deliveryTaskMarkersList, function (taskMarker) {
        taskMarker.setMap(null);
      });
      this.$scope.deliveryTaskMarkersList = [];
    }
  }

  removeSuggestionsTaskMarkersFromMap() {
    if (!_.isUndefined(this.$scope.taskSuggestions) && !_.isEmpty(this.$scope.taskSuggestions)) {
      _.forEach(this.$scope.taskSuggestions, (taskMarker) => {
        taskMarker.setMap(null);
      });
      this.$scope.taskSuggestions = [];
    }
  }

  resetAllMarkersSelected() {
    _.forEach(this.$scope.deliveryTaskMarkersList, (marker) => {
      marker.setAnimation(null);
    })
  }

  registerToEvents(marker) {
    marker.addListener('click', () => {
      this.stopAllOtherMarkerBounce(marker.id);
      this.$rootScope.$broadcast('highlight-stopover-from-marker', marker.id);
      marker.setAnimation(google.maps.Animation.BOUNCE);
      this.$rootScope.$applyAsync();
    });
  }

}

angular
  .module('bringoz.admin.map')
  .component('bringozMap', {
    bindings: {
      deliveryTaskIds: '<',
      selectDelivery: '<',
      selectedDeliveriesIds: '<',
      deliveryTasks: '<',
      createOrderTasks: '<',
      circles: '<',
      simpleMap: '<'
    },
    template: require('./bringoz-map.html').default,
    controller: BringozMapComponent
  });
